"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInAppAgentInstrumentationTraceId = exports.getInAppAgentInstrumentationObservationId = exports.IN_APP_AGENT_LOCAL_SANDBOX_IMAGE = exports.IN_APP_AGENT_MCP_TOOL_OVERRIDE_HEADER = exports.IN_APP_AGENT_MCP_USER_AGENT = exports.IN_APP_AGENT_TOOL_REJECTION_ERROR_CODE = exports.IN_APP_AGENT_REDIRECT_TOOL_NAME = void 0;
// Avoid renaming this as the FE is aware of this when rendering, renaming it would cause history issues
exports.IN_APP_AGENT_REDIRECT_TOOL_NAME = "langfuse_proposeRedirect";
exports.IN_APP_AGENT_TOOL_REJECTION_ERROR_CODE = "tool_call_rejected";
exports.IN_APP_AGENT_MCP_USER_AGENT = "langfuse-in-app-agent";
// Header used only by Langfuse's server-side in-app agent when it calls the
// Langfuse MCP endpoint with a temporary in-app-agent API key and run override.
exports.IN_APP_AGENT_MCP_TOOL_OVERRIDE_HEADER = "x-langfuse-in-app-agent-tool-override";
exports.IN_APP_AGENT_LOCAL_SANDBOX_IMAGE = "langfuse-in-app-agent-sandbox:latest";
// Observation ids stay equal to the per-turn run id so persisted messages,
// feedback, and traced generations all point at the same Langfuse observation.
const getInAppAgentInstrumentationObservationId = (runId) => runId;
exports.getInAppAgentInstrumentationObservationId = getInAppAgentInstrumentationObservationId;
// Each in-app agent turn gets its own trace derived from the run id so trace-
// level telemetry and feedback aggregate on the same per-turn trace.
const getInAppAgentInstrumentationTraceId = (runId) => `${runId}-trace`;
exports.getInAppAgentInstrumentationTraceId = getInAppAgentInstrumentationTraceId;
